export const SUBMIT_SUGGESTION_REQUEST = 'suggestion/SUBMIT_REQUEST';
export const SUBMIT_SUGGESTION_SUCCESS = 'suggestion/SUBMIT_SUCCESS';
export const SUBMIT_SUGGESTION_FAILURE = 'suggestion/SUBMIT_FAILURE';
export const SUGGESTION_RESET = 'suggestion/RESET';
